// extracted by mini-css-extract-plugin
module.exports = {"container":"_1789a38","image":"_bf97bfb","title":"_ac46806","text":"_d99f2be","controlHeight":"_44c140d"};